<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { ChevronRightIcon } from "@radix-icons/vue"
import { PaginationPrev, type PaginationPrevProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

import Button from "../button/Button.vue"

const {
	class: rawClass,
	asChild = true,
	...props
} = defineProps<PaginationPrevProps & { class?: HTMLAttributes["class"] }>()

const className = useClass(
	"size-9 p-0",
	() => rawClass,
)
</script>

<template>
	<PaginationPrev
		v-bind="props"
		:as-child>
		<Button
			:class="className"
			variant="outline">
			<slot>
				<ChevronRightIcon />
			</slot>
		</Button>
	</PaginationPrev>
</template>
